import compose from 'lodash/fp/compose';
import join from 'lodash/fp/join';
import split from 'lodash/fp/split';
import lowerCase from 'lodash/lowerCase';

export const createRegExp = compose(
  v => new RegExp(v),
  join('.*'),
  split(''),
  lowerCase,
);

export const matchSearch = (search, value) => lowerCase(value).match(createRegExp(search));

export const filterOption = (input, option) => {
  return matchSearch(input, option?.label);
};
